'use client';

var translations = {
    'Share to...': 'Share to...',
    'Share by ': 'Share by ',
    'Copy link': 'Copy link'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
